import services from '../services'
import * as types from './mutation-types'

export const getAll = ({ commit }) => (
  services.list().then(res => {
    commit(types.SET_CUSTOM_LISTS, res.data)
  })
)

export const show = async ({ commit }, id) => {
  await services.show(id).then(res => {
    commit(types.SET_CUSTOM_LIST, res.data.data)
  })
}

export const save = async ({ commit }, obj) => {
  await services.save(obj).then(res => {
    return res
  })
}

export const destroy = async ({ commit }, id) => {
  await services.destroy(id).then(res => {
    return res
  })
}

export const getItems = ({ commit }, { listId, params }) => (
  services.getItems(listId, params).then(res => {
    commit(types.SET_CUSTOM_LIST_ITEMS, res.data)
  })
)

export const saveItem = async ({ commit }, { listId, item }) => {
  await services.saveItem(listId, item).then(res => {
    return res
  })
}

export const destroyItem = async ({ commit }, { listId, itemId }) => {
  await services.destroyItem(listId, itemId).then(res => {
    return res
  })
}

export const importItems = async ({ commit }, { listId, formData }) => {
  await services.importItems(listId, formData).then(res => {
    return res
  })
}
